import { Component } from '@angular/core';
import { MetaService } from '@shared/services/meta/meta.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {

  constructor(
    private metaService: MetaService
  ) {
    this.metaService.setTitleExternalPage('Maintenance');
  }

}
